<template>
  <Layout>
    <div v-if="!isPrintable" class="text-center d-print-none">
      <h2 class="d-print-none">Preparing to print <i class="fas fa-spinner fa-spin"></i></h2>
    </div>
    <print @isPrintReady="print" :mobile-shipment-id="this.$route.params.shipmentId"></print>
  </Layout>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import Layout from '../layouts/blank'
import Print from './white-glove/print'
import VueHtmlToPaper from 'vue-html-to-paper'
import Vue from 'vue'

Vue.use(VueHtmlToPaper)

export default {
  data () {
    return {
      isPrintable: false
    }
  },
  components: {
    Print, Layout, VueHtmlToPaper
  },
  methods: {
    print () {
      setTimeout(() => {
        this.isPrintable = true
        const options = {
          styles: [
            '/print.css'
          ]
        }
        this.$htmlToPaper('print-manifest', options, () => {
          window.location.href = 'fashionphile://'
        })
      }, 1000)
    }
  }
}
</script>
